import { AppService } from '@ajin/services/app.service';
import { Platform } from '@angular/cdk/platform';
import { Component, HostListener, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { StatusBar, Style } from '@capacitor/status-bar';
import { FuseConfigService } from '@fuse/services/config';
import { TranslocoService } from '@ngneat/transloco';
import { AuthService } from '@projects/core/auth/auth.service';
import { AppUpdateService } from '@projects/core/services/app-update.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: true,
	imports: [RouterOutlet
	]
})
export class AppComponent implements OnInit {
	private _app = inject(AppService);
	private _fuseConfigService = inject(FuseConfigService);
	private _translocoService = inject(TranslocoService);
	private _platform = inject(Platform);
	private _updateService = inject(AppUpdateService);
	private _authService = inject(AuthService);


	@HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
		this._app?.event?.next('esc');
	}

	constructor(
	) {
		this._updateService.verifyUpdate();
		this._setNativeScreen();

		const theme = localStorage.getItem('theme');
		if (theme)
			this._fuseConfigService.config = { theme };

		const scheme = localStorage.getItem('scheme');
		if (scheme)
			this._fuseConfigService.config = { scheme };


	}

	ngOnInit() {
	}

	private _setNativeScreen() {
		if (!this._app?.isNative)
			return;

		alert('setNativeScreen');
		// iOS only
		window.addEventListener('statusTap', function () {
			// this.setStatusBarStyleDark();
		});

		// Display content under transparent status bar (Android only)
		StatusBar.setOverlaysWebView({ overlay: true });

		const setStatusBarStyleDark = async () => {
			await StatusBar.setStyle({ style: Style.Dark });
		};

		const setStatusBarStyleLight = async () => {
			await StatusBar.setStyle({ style: Style.Light });
		};

		const hideStatusBar = async () => {
			await StatusBar.hide();
		};

		const showStatusBar = async () => {
			await StatusBar.show();
		};
	}
}
